import React from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { Container, Card, CardBody, Button, ListGroup, ListGroupItem } from "reactstrap";

export default function PlanDetail() {
  const { planId } = useParams();
  const { state } = useLocation(); // comes from navigate()
  const navigate = useNavigate();

  if (!state) {
    return (
      <Container className="mt-5 pt-5 text-center">
        <h3>Plan details not found</h3>
        <Button color="dark" onClick={() => navigate("/")}>
          Go Back
        </Button>
      </Container>
    );
  }

  const { title, price, users, features } = state;

  return (
    <Container className="mt-5 pt-5">
      <Card className="shadow-lg">
        <CardBody>
          <h2 className="mb-3">{title}</h2>
          <p className="text-muted">{users}</p>
          <h3>
            £{price} <small className="text-muted">/ user/month</small>
          </h3>
          <h5 className="mt-4 mb-2">Features:</h5>
          <ListGroup flush>
            {features.map((feature, idx) => (
              <ListGroupItem key={idx} className="border-0 ps-0">
                <i className="bx bx-check text-success me-2"></i>
                {feature}
              </ListGroupItem>
            ))}
          </ListGroup>
          <div className="mt-4 d-flex justify-content-between">
            <Button color="secondary" onClick={() => navigate("/")}>
              Back to Plans
            </Button>
            <Button color="dark">Proceed with {title}</Button>
          </div>
        </CardBody>
      </Card>
    </Container>
  );
}
